import React from "react";
import PropTypes from "prop-types";

// Figma "Quick Reply": pill badges beside the pitcher's name — on virtual pitch rows AND
// on the request-page rail's conversation rows (both row types read as one list).
function PitchBadges({ fast = false, flagged = false, muted = false, reported = false }) {
  if (!fast && !flagged && !muted && !reported) return null;
  return (
    <>
      {fast && (
        <span className="badge rounded-pill bg-transparent flex-shrink-0 fw-semibold pi-badge-fast">
          <i className="fa-solid fa-circle-exclamation me-1" aria-hidden="true" />
          Fast Pitch
        </span>
      )}
      {flagged && (
        <span className="badge rounded-pill bg-transparent flex-shrink-0 fw-semibold pi-badge-flagged">
          <i className="fa-solid fa-circle-exclamation me-1" aria-hidden="true" />
          Flagged
        </span>
      )}
      {muted && (
        <span
          className="pi-type-badge pi-muted-badge flex-shrink-0"
          title="You muted this user — new pitches from them are hidden"
        >
          <i className="fa-solid fa-volume-xmark me-1" aria-hidden="true" />
          Muted
        </span>
      )}
      {reported && (
        <span
          className="pi-type-badge pi-reported-badge flex-shrink-0"
          title="You reported this pitch — our team will review it"
        >
          <i className="fa-regular fa-flag me-1" aria-hidden="true" />
          Reported
        </span>
      )}
    </>
  );
}

PitchBadges.propTypes = {
  fast: PropTypes.bool,
  flagged: PropTypes.bool,
  muted: PropTypes.bool,
  reported: PropTypes.bool,
};

export default PitchBadges;
